// Development(Staging), QA, Production
//export const authRequestBQS: any = {
//    scopes: ["api://0ca12f8b-14ac-42ad-b08d-b68a99f86af9/readwrite"],
//};
export const authRequestBQS: any = {
    scopes: ["api://e2ee1b11-d4ca-44a7-85c6-3a377a16533b/readwrite"],
};

export const authRequestCQS: any = {
    scopes: ["api://f503f56e-83d7-4556-8dc9-5b2a98a884f4/readwrite"],
};

export const authRequestBc: any = {
    scopes: ["https://api.businesscentral.dynamics.com/user_impersonation"]
};

export const configurationBQS: any = {

    auth: {
        //clientId: "1bedb308-9b4e-431f-994c-dce98709196a",
        //authority: "https://login.microsoftonline.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1",
        clientId: "e2ee1b11-d4ca-44a7-85c6-3a377a16533b",
        authority: "https://login.microsoftonline.com/87e91054-89e7-4abb-84e9-65db18a873f2",
        redirectUri: "https://bqs-dev-bc.highstepsites.com/",
        postLogoutRedirectUri: "https://bqs-dev-bc.highstepsites.com/",
    },
    cache: {
        cacheLocation: "localStorage", // or "sessionStorage"
        storeAuthStateInCookie: false,
    },
};

export const configurationCQS: any = {

    auth: {
        clientId: "1bedb308-9b4e-431f-994c-dce98709196a",
        authority: "https://login.microsoftonline.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1",
        redirectUri: "https://cqs.localhost:5001",
        postLogoutRedirectUri: "https://cqs.localhost:5001",
    },
    cache: {
        cacheLocation: "localStorage", // or "sessionStorage"
        storeAuthStateInCookie: false,
    },
};


// WEBPACK FOOTER //
// ./ClientApp/config.qa.ts